import React from 'react'
import Reports from './Reports'
import { useTranslation } from 'react-i18next'

const EmployeeLevel = () => {
  const { t } = useTranslation()
  const columns = [
    {
      title: ('reports.employeeLevel.employee'),
      title1: 'reports.employeeLevel.employee',
      field: 'workerId',
      headerAlign: 'center',
      editable: 'never'
    },
    {
      title: ('reports.employeeLevel.paidTime'),
      title1: 'reports.employeeLevel.paidTime',
      field: 'paidTime',
      sortable: false,
      editable: 'never'
    },
    {
      title: ('reports.employeeLevel.gdeTime'),
      title1: 'reports.employeeLevel.gdeTime',
      field: 'gdeTime',
      sortable: false,
      editable: 'never'
    },
    {
      title: ('reports.employeeLevel.timeKeying'),
      title1: 'reports.employeeLevel.timeKeying',
      field: 'keyedTime',
      headerAlign: 'center',
      textAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.employeeLevel.dataEntryKeyStrokes'),
      title1: 'reports.employeeLevel.dataEntryKeyStrokes',
      field: 'dataEntryKeyStrokes',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.employeeLevel.verifyKeyStrokes'),
      title1: 'reports.employeeLevel.verifyKeyStrokes',
      field: 'verificationKeyStrokes',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.employeeLevel.totalKeyStrokes'),
      title1: 'reports.employeeLevel.totalKeyStrokes',
      field: 'keyStrokeCount',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.employeeLevel.boxes'),
      title1: 'reports.employeeLevel.boxes',
      field: 'totalBoxCount',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.employeeLevel.files'),
      title1: 'reports.employeeLevel.files',
      field: 'totalRecordCount',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.employeeLevel.kphGde'),
      title1: 'reports.employeeLevel.kphGde',
      field: 'kphGde',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.employeeLevel.kphTime'),
      title1: 'reports.employeeLevel.kphTime',
      field: 'kphTime',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.employeeLevel.keyingTime'),
      title1: 'reports.employeeLevel.keyingTime',
      field: 'keyedTimeGDETime',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    },
    {
      title: ('reports.employeeLevel.paidTimeGdeTime'),
      title1: 'reports.employeeLevel.paidTimeGdeTime',
      field: 'paidTimeGdeTime',
      headerAlign: 'center',
      editable: 'never',
      sortable: false
    },
  ]

  return <>
    <Reports columns={columns} pageTitle={t('reports.employeeLevel.title')} isEmployeeLevel/>
  </>
}

export default EmployeeLevel